<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Supplier Management <small class="text-muted">suppliers</small>
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->

          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('supplier.primary_name') }}</th>
                            <th>{{ $t('supplier.secondary_name') }}</th>
                            <th>{{ $t('supplier.address') }}</th>
                            <th>{{ $t('supplier.postal_address') }}</th>
                            <th>{{ $t('supplier.email') }}</th>
                            <th>{{ $t('supplier.tel') }}</th>
                            <th>{{ $t('supplier.fax') }}</th>
                            <th>{{ $t('supplier.contact_person') }}</th>
                            <th>{{ $t('supplier.status') }}</th>
                            <th>{{ $t('supplier.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(supplier, index) in suppliers" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ supplier.primary_name }}</td>
                            <td>{{ supplier.secondary_name }}</td>
                            <td>{{ supplier.address }}</td>
                            <td>{{ supplier.postal_address }}</td>
                            <td>{{ supplier.email }}</td>
                            <td>{{ supplier.tel }}</td>
                            <td>{{ supplier.fax }}</td>
                            <td>{{ supplier.contact_person }}</td>
                            <td>
                              <span class="badge badge-success" v-if="supplier.status">{{ $t('supplier.active') }}</span>
                              <span class="badge badge-secondary" v-else>{{ $t('supplier.in_active') }}</span>
                            </td>
                            <td>
                              <router-link :to="{ path: '/supplier/' + supplier.id + '/edit' }">
                                <CButton size="sm" color="primary" class="mr-1" ><i class="fa fa-pencil"></i></CButton>
                              </router-link>
                               <!-- <CButton size="sm" color="danger" @click.stop.prevent="handleDelete(supplier.id)"><i class="fa fa-trash"></i></CButton> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>   
</div>
</template>

<script>
import HeaderButton from '@/views/components/supplier/HeaderButton'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'Suppliers',
  components: {
    HeaderButton,
    LoadingPanel
  },
  mounted () {
    this.querySuppliers();
  },
  data () {
    return {
      suppliers: [],
      showLoadingPanel: false
    }
  },
  methods: {
    querySuppliers() {
      this.axios.get('/supplier').then(response => {
        this.suppliers = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    handleDelete (shiperId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button'),
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/supplier/' + shiperId).then(() => {
            this.showLoadingPanel = false
            this.querySuppliers();
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
